export default "__VITE_ASSET__89734846__"